import { createBrowserClient } from "@supabase/ssr"

// Singleton instance for non-React contexts (utilities, etc.)
let clientInstance: ReturnType<typeof createBrowserClient> | null = null

/**
 * Creates or returns a singleton Supabase client for browser environments.
 * 
 * Note: For React components, prefer using the useSupabase() hook from the SupabaseProvider context.
 * This function is primarily for use in non-React utilities (e.g., encryption utils).
 * 
 * @returns A Supabase client instance
 */
export function createClient() {
  if (typeof window === "undefined") {
    throw new Error("createClient from '@/lib/supabase/client' should only be used in browser environments. Use '@/lib/supabase/server' for server-side code.")
  }

  if (!clientInstance) {
    const url = process.env.NEXT_PUBLIC_SUPABASE_URL
    const key = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY

    if (!url || !key) {
      throw new Error("Supabase environment variables (NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_ANON_KEY) are required but not available.")
    }

    clientInstance = createBrowserClient(url, key)
  }

  return clientInstance
}
